import { gql, useMutation } from "@apollo/client";
import { Modal, GenerateMeterDeliveryMaterialsForm } from "components";
import { useFormik } from "formik";
import { FC } from "react";
import toast from "react-hot-toast";
import { wrapClick } from "utils";
import {
  GenerateMeterDeliveryMaterialsInitialValues,
  GenerateMeterDeliveryMaterialsSchema,
} from "components/forms";
import { useMatch } from "react-location";
import { LocationGenerics } from "router/location";

const GENERATE_METER_DELIVERY_MATERIALS = gql`
  mutation GenerateMeterDeliveryRequestMaterials(
    $deliveryRequest: ID!
    $materials: [MeterDeliveryRequestMaterialsMaterialInput!]!
    $notes: String
  ) {
    generateMeterDeliveryRequestMaterials(
      deliveryRequest: $deliveryRequest
      materials: $materials
      notes: $notes
    ) {
      _id
    }
  }
`;

interface GenerateMeterDeliveryMaterialsContainerProps {
  open: boolean;
  setOpen: (val: boolean) => void;
  refetch?: () => void;
}


const GenerateMeterDeliveryMaterialsContainer: FC<GenerateMeterDeliveryMaterialsContainerProps> = ({
  open,
  setOpen,
  refetch,
}) => {
  const [generateMeterDeliveryMaterials, { loading }] = useMutation(
    GENERATE_METER_DELIVERY_MATERIALS
  );

  const { params } = useMatch<LocationGenerics>();

  const form = useFormik<any>({
    initialValues: GenerateMeterDeliveryMaterialsInitialValues,
    validationSchema: GenerateMeterDeliveryMaterialsSchema,
    onSubmit: async (values) => {
      await generateMeterDeliveryMaterials({
        variables: {
          ...values,
          deliveryRequest: params.deliveryRequest,
        },
      }).then(({ data }) => {
        if (data.generateMeterDeliveryRequestMaterials._id) {
          toast(
            JSON.stringify({
              type: "success",
              title: "Complementary materials submitted successfully",
            })
          );
          refetch?.();
          form.resetForm();
        } else {
          toast(
            JSON.stringify({ type: "error", title: "Could not submit complementary materials" })
          );
        }
      });
    },
    onReset: () => {
      setOpen(false);
    },
  });

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      title='Submit Complementary Materials Requisition'
      description='Provide the details to submit the complementary materials list'
      renderActions={() => (
        <>
          <button
            type='button'
            disabled={loading}
            className='w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary-600 text-base font-medium text-white hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 sm:ml-3 sm:w-auto sm:text-sm'
            onClick={wrapClick(form.handleSubmit)}
          >
            {loading ? "Submitting Materials..." : "Submit Materials"}
          </button>
        </>
      )}
    >
      <GenerateMeterDeliveryMaterialsForm form={form} />
    </Modal>
  );
};

export default GenerateMeterDeliveryMaterialsContainer;
